/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var _ = require('underscore');
var SelectFieldView = require('common/views/SelectFieldView');

var ConSerContactInformationView = require('./ConSerContactInformationView');

var tmplConSerComplaintContactInformationDisplayView = require('../templates/ConSerComplaintContactInformationDisplayView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplConSerComplaintContactInformationDisplayView,

  className: 'con-ser-contact-display-view',

  ui: {
    addressContainer: '.address-container',
    contactSelectField: '[name="contactId"]',
    contactSelect: '.select-contact',
    contactInformationContainer: '.contact-information-container',
    addContact: '.btn-add-cs-contact',
    deleteContact: '.btn-delete-cs-contact',
    includeInactiveLicensesCheckbox: '.include-inactive-licenses-checkbox'
  },

  regions: {
    addressContainer: '@ui.addressContainer',
    contactInformationContainer: '@ui.contactInformationContainer',
    contactSelect: '@ui.contactSelect'
  },

  events: {
    'change @ui.contactSelectField': 'onChangeContactSelectField',
    'change @ui.includeInactiveLicensesCheckbox': 'onChangeInactiveLicensesCheckbox'
  },

  triggers: {
    'click @ui.addContact': 'add:contact',
    'click @ui.deleteContact': 'delete:contact'
  },

  onBeforeShow: function() {
    // renders contact information view
    var contact = this.model.attributes || {};
    this.contact = contact;

    this.contactSelect = new SelectFieldView({
      name: 'contactId',
      collection: new Backbone.Collection([])
    });
    this.resetContactSelectOptions();
    this.showChildView('contactSelect', this.contactSelect);
    Syphon.deserialize(this, contact);

    var selectedContact = _.findWhere(this.model.get('contacts'), { contactId: contact.contactId });

    this.renderContactInformationView(selectedContact);

    // renders old contact information
    /*this.showChildView(
      'contactOldInformationContainer',
      new ConSerContactInformationView({
        model: new Backbone.Model(contact || {})
      })
    );*/
  },

  onChangeContactSelectField: function(e) {
    var contact = this.getSelectedContact() || {};
    this.contact = contact;

    this.renderContactInformationView(contact);
  },

  onChangeInactiveLicensesCheckbox: function(e) {
    this.resetContactSelectOptions();
    Syphon.deserialize(this, this.contact);
  },

  renderContactInformationView: function(contact) {
    // changes contact display information
    this.showChildView(
      'contactInformationContainer',
      new ConSerContactInformationView({
        model: new Backbone.Model(contact || {})
      })
    );
  },

  resetContactSelectOptions: function() {
    var contact = this.contact;
    var isIncludeInactiveChecked = this.ui.includeInactiveLicensesCheckbox.prop('checked');
    if (!isIncludeInactiveChecked) {
      var allContacts = this.model.get('contacts');
      var ndInactiveLicenses = ['3', '4', '6', '8', '9', '10', '11', '12', '14', '15', '16', '21'];
      var contacts = allContacts.filter(function(contact) {
        return !_.contains(ndInactiveLicenses, contact.licenseStatusId);
      });

      var currentContact = _.findWhere(contacts, { contactId: contact.contactId });
      if (_.isUndefined(currentContact)) {
        var addContact = _.findWhere(allContacts, { contactId: contact.contactId });
        if (!_.isUndefined(addContact)) {
          contacts.push(addContact);
        }
      }

      this.model.set('filteredContacts', contacts);
    } else {
      this.model.set('filteredContacts', this.model.get('contacts'));
    }

    this.contactSelect.collection.reset(
      _.map(this.model.get('filteredContacts'), function(contact) {
        return { value: contact.contactId, text: contact.contactType };
      })
    );
  },

  getSelectedContact: function() {
    var contactId = this.contactSelect.getValue();
    var contact = _.findWhere(this.model.get('contacts'), { contactId: contactId });

    return contact;
  },

  getFormData: function() {
    return this.contact;
  }
});
